import { createFeatureSelector, createSelector } from '@ngrx/store';
import { each } from 'lodash-es';
import { QueryResultsModel } from '../../../../core/_base/crud';
import { Template } from '../models';
import { TemplateState } from '../reducers/template.reducer';

export const selectTemplateState = createFeatureSelector<TemplateState>('template');

export const selectTemplatePageLoading = createSelector(
  selectTemplateState,
  (state) => state.pageLoading,
);

export const selectTemplateActionLoading = createSelector(
  selectTemplateState,
  (state) => state.actionLoading,
);

export const selectTemplateShowInitWaitingMessage = createSelector(
  selectTemplateState,
  (state) => state.showInitWaitingMessage,
);

export const selectTemplateError = createSelector(selectTemplateState, (state) => state.error);

export const selectTemplatePage = createSelector(selectTemplateState, (state) => {
  const templates: Template[] = [];
  each(state.ids, (id: number) => templates.push(state.entities[id]));

  return new QueryResultsModel(templates, state.totalCount);
});
